import { useTranslation } from "react-i18next";

function Error() {
	const { t } = useTranslation();

	return <div>{t("common:error.label")}</div>;
}

export default Error;
